import moment from 'moment'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMemo } from 'modules/core/hooks/useMemo'

interface ReturnType {
  dateFormat: string
  availableFormats: string[]
}

const useGetDateFormat = (): ReturnType => {
  const { access } = useCurrentSession()

  const dateFormat = useMemo(() => {
    return moment.localeData(access.locale).longDateFormat('L')
  }, [access.locale])

  const availableFormats = useMemo(() => {
    const separators = ['/', '-']
    const splitCharacter = dateFormat.includes('/') ? '/' : '-'

    const formatsBySeparator = separators.map((separator) =>
      dateFormat.split(splitCharacter).join(separator)
    )
    const formatsBySeparatorShorted = formatsBySeparator.map((format) =>
      format.replace(/DD/g, 'D').replace(/MM/g, 'M')
    )

    return [...formatsBySeparator, ...formatsBySeparatorShorted]
  }, [dateFormat])

  return {
    dateFormat,
    availableFormats,
  }
}

export default useGetDateFormat
